import List from './List';
import Show from './Show';

export default {
    list: List,
    show: Show,
};
